import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { Box, Link } from '@stashinvest/ui';
import { Drawer, Text } from '@stashinvest/ui/dist/es/2';

const TextPreview = styled(Link)`
	display: block;
	background: ${({ theme }) => theme.colors.bgPrimary};
	padding: 0;
`;

const TextMore = styled(Text.Body12)`
	position: relative;
	overflow: hidden;

	&:after {
		position: absolute;
		bottom: 0;
		right: 0;
		padding-right: 36px;
		padding-left: 10px;
		content: '…';
		background: ${({ theme }) => theme.colors.bgPrimary};
		background: linear-gradient(
			90deg,
			transparent 0%,
			${({ theme }) => theme.colors.bgPrimary} 10px
		);
	}
`;

const Morelink = styled(Text.Body12)`
	position: absolute;
	bottom: 0;
	right: 0;
	text-decoration: underline;
	z-index: 1;
`;

const Disclosure = ({ heading, copy, lineClamp }) => {
	const [showMore, setShowMore] = useState(false);
	const copyArray = typeof copy === 'string' ? [copy] : copy;

	return (
		<>
			<TextPreview
				as="button"
				type="button"
				onClick={() => setShowMore(true)}
				unstyled
			>
				<TextMore color="textTertiary" lineClamp={lineClamp} align="left">
					{copyArray[0]}
					<Morelink as="span" color="textTertiary">
						More
					</Morelink>
				</TextMore>
			</TextPreview>
			{showMore && (
				<Drawer onDismiss={() => setShowMore(false)}>
					<Box p="s24" maxHeight="90vh" overflowY="auto">
						{Boolean(heading) && (
							<Text.Title24 mb="s20" fontWeight="bold">
								{heading}
							</Text.Title24>
						)}
						{copyArray?.map((paragraph, idx) => (
							<Text.Body14
								key={idx}
								color="textSecondary"
								mb={idx < copyArray.length - 1 ? 's24' : '0'}
							>
								{paragraph}
							</Text.Body14>
						))}
					</Box>
				</Drawer>
			)}
		</>
	);
};

Disclosure.defaultProps = {
	copy: [],
	lineClamp: 2,
};

Disclosure.propTypes = {
	heading: PropTypes.string,
	copy: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
	lineClamp: PropTypes.number,
};

export default Disclosure;
